<div id="mtls-certificate-section">
  <div
    class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-sm-between gap-2 mb-3"
  >
    <div class="d-flex align-items-center">
      <p class="fs-17 mb-0">
        <strong>Certificado mTLS</strong>
      </p>
    </div>
    <span
      class="badge rounded-pill d-inline-flex align-items-center"
      [ngClass]="statusBadgeClass"
    >
      <mat-icon
        class="align-middle me-1"
        style="font-size: 14px; width: 14px; height: 14px"
      >
        {{ statusIcon }}
      </mat-icon>
      {{ statusLabel }}
    </span>
  </div>

  <div
    *ngIf="!isMtlsEnabled"
    class="mtls-empty-state text-center py-4 px-3 round-border bg-light mb-7"
  >
    <mat-icon
      class="text-muted mb-2"
      style="font-size: 40px; width: 40px; height: 40px"
    >
      lock
    </mat-icon>
    <p class="text-muted mb-0">
      mTLS não está habilitado para esta conta.<br />
      <small>Entre em contato com o suporte para ativar.</small>
    </p>
  </div>

  <div *ngIf="isMtlsEnabled && !hasMtlsCertificate" class="mtls-generate-state">
    <ngb-alert type="warning" [dismissible]="false" class="round-border">
      <strong class="certificate-text">Nenhum certificado gerado</strong>
      <hr class="message-inner-separator" />
      <span class="certificate-text">
        Gere um certificado digital para autenticação mTLS. Após a geração, faça
        o download do arquivo <code>.p12</code> e configure nos seus servidores.
      </span>
    </ngb-alert>
    <div class="d-grid d-sm-block">
      <button
        type="button"
        class="btn btn-pill btn-primary d-inline-flex align-items-center justify-content-center mb-6"
        [disabled]="isGeneratingCertificate"
        (click)="downloadMtlsCertificate()"
      >
        <mat-icon
          *ngIf="!isGeneratingCertificate"
          class="me-1"
          style="font-size: 18px; width: 18px; height: 18px"
        >
          download
        </mat-icon>
        <span
          *ngIf="isGeneratingCertificate"
          class="spinner-border spinner-border-sm me-2"
          role="status"
        ></span>
        {{ generateCertificateLabel }}
      </button>
    </div>
  </div>

  <div *ngIf="isMtlsEnabled && hasMtlsCertificate" class="mtls-active-state ">
    <ngb-alert type="success" [dismissible]="false" class="round-border">
      <strong class="certificate-text">Certificado configurado</strong>
      <hr class="message-inner-separator" />
      <span class="certificate-text">
        Seu certificado mTLS está ativo. Use a rotação para gerar um novo
        certificado e revogar o atual.
      </span>
    </ngb-alert>
    <div
      *ngIf="certificateExpiresAt"
      class="d-flex align-items-center mb-3 p-2 ps-5 round-border"
      [ngClass]="
        isExpirationNear
          ? 'bg-warning bg-opacity-10 border border-warning'
          : 'bg-light'
      "
    >
      <mat-icon
        class="me-2 flex-shrink-0"
        [ngClass]="
          isExpired
            ? 'text-danger'
            : isExpirationNear
              ? 'text-warning'
              : 'text-muted'
        "
        style="font-size: 20px; width: 20px; height: 20px"
      >
        {{ isExpired ? "error" : isExpirationNear ? "warning" : "event" }}
      </mat-icon>
      <div class="d-flex flex-column">
        <small
          class="fw-semibold"
          [ngClass]="
            isExpired
              ? 'text-danger'
              : isExpirationNear
                ? 'text-warning'
                : 'text-muted'
          "
        >
          Expira em: {{ formattedExpirationDate }}
        </small>
        <small
          *ngIf="isExpirationNear"
          [ngClass]="isExpired ? 'text-danger' : 'text-warning'"
        >
          {{ expirationMessage }}
        </small>
      </div>
    </div>
    <div class="d-grid d-sm-block">
      <button
        type="button"
        class="btn btn-pill btn-primary d-inline-flex align-items-center justify-content-center mb-6" 
        [disabled]="isRotatingCertificate"
        ngbTooltip="Gera um novo certificado e revoga o anterior"
        placement="top"
        (click)="openRotateCertificateConfirm(rotateCertificateConfirmModal)"
      >
        <mat-icon
          *ngIf="!isRotatingCertificate"
          class="me-1"
          style="font-size: 18px; width: 18px; height: 18px"
        >
          sync
        </mat-icon>
        <span
          *ngIf="isRotatingCertificate"
          class="spinner-border spinner-border-sm me-2"
          role="status"
        ></span>
        {{ rotateCertificateLabel }}
      </button>
    </div>
  </div>
</div>

<ng-template #rotateCertificateConfirmModal let-modal>
  <div class="modal-header border-bottom-0">
    <h5 class="modal-title d-flex align-items-center">
      <mat-icon
        class="text-warning me-2"
        style="font-size: 24px; width: 24px; height: 24px"
      >
        warning
      </mat-icon>
      {{ "common.rotateCertificateQuestionTitle" | translate }}
    </h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <p class="mb-2">
      {{ "common.rotateCertificateQuestionBody" | translate }}
    </p>
    <ngb-alert type="warning" [dismissible]="false" class="mb-0">
      <strong>Atenção</strong>
      <hr class="message-inner-separator" />
      <span>
        O certificado atual será revogado imediatamente. Atualize a configuração
        nos seus servidores após o download do novo certificado.
      </span>
    </ngb-alert>
  </div>
  <div class="modal-footer border-top-0 d-grid d-sm-flex gap-2">
    <button
      type="button"
      class="btn btn-light order-2 order-sm-1"
      (click)="modal.dismiss('cancel')"
    >
      Cancelar
    </button>
    <button
      type="button"
      class="btn btn-warning text-white d-inline-flex align-items-center justify-content-center order-1 order-sm-2"
      (click)="rotateMtlsCertificate(modal)"
    >
      <mat-icon class="me-1" style="font-size: 18px; width: 18px; height: 18px">
        sync
      </mat-icon>
      Rotacionar e baixar
    </button>
  </div>
</ng-template>
